// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DropDownMenu-menuBg-DXdJB {
    width: 78px;
    height: 44px;
    background: var(--common-primary-gray);
    border-radius: 22px;
    display: grid;
    grid-template-columns: 50% 50%;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    padding: 0 10px 0 12px;
    cursor: pointer;
}

.DropDownMenu-icon-VZZhF {
    height: 50px
}

.DropDownMenu-userAvatar-hYb8g {
    border-radius: 50%;
}

.DropDownMenu-notification-Br5Fr {
    background: var(--alert-color);
    height: 8px;
    width: 8px;
    position: absolute;
    top: 3px;
    right: 10px;
    border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/DropDownMenu/DropDownMenu.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,kBAAkB;AACtB","sourcesContent":[".menuBg {\n    width: 78px;\n    height: 44px;\n    background: var(--common-primary-gray);\n    border-radius: 22px;\n    display: grid;\n    grid-template-columns: 50% 50%;\n    align-items: center;\n    justify-content: center;\n    padding: 0 10px 0 12px;\n    cursor: pointer;\n}\n\n.icon {\n    height: 50px\n}\n\n.userAvatar {\n    border-radius: 50%;\n}\n\n.notification {\n    background: var(--alert-color);\n    height: 8px;\n    width: 8px;\n    position: absolute;\n    top: 3px;\n    right: 10px;\n    border-radius: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuBg": `DropDownMenu-menuBg-DXdJB`,
	"icon": `DropDownMenu-icon-VZZhF`,
	"userAvatar": `DropDownMenu-userAvatar-hYb8g`,
	"notification": `DropDownMenu-notification-Br5Fr`
};
module.exports = ___CSS_LOADER_EXPORT___;
